export const SUBMODULE_NAME = 'whiteSpaceAutomation';
